import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ThemeState {
  selectedTheme: {
    id: string;
    theme: string;
  } | null;
}

const initialState: ThemeState = {
  selectedTheme: null,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setSelectedTheme: (
      state,
      action: PayloadAction<{ id: string; theme: string }>
    ) => {
      state.selectedTheme = action.payload;
    },
    clearSelectedTheme: (state) => {
      state.selectedTheme = null;
    },
  },
});

export const { setSelectedTheme, clearSelectedTheme } = themeSlice.actions;

export default themeSlice.reducer;
